/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { loadRemoteModuleAsync } from '@anecdotes/architecture-tools';

export const dashboardApp = {
  loadDashboardAsync: () => loadRemoteModuleAsync('dashboard', (remoteEntry) => remoteEntry.RemoteEntryModule),
};

export const evidencePoolApp = {
  loadEvidencePoolAsync: () => loadRemoteModuleAsync('evidence-pool', (remoteEntry) => remoteEntry.RemoteEntryModule)
};

export const trustCenterApp = {
  loadTrustCenterAsync: () => loadRemoteModuleAsync('trustcenter', (remoteEntry) => remoteEntry.RemoteEntryModule)
};

export const policyManagerApp = {
  loadPolicyManagerAsync: () => loadRemoteModuleAsync('policy-manager', (remoteEntry) => remoteEntry.PolicyManagerModule),
  loadPolicyExternalApprovalAsync: () => loadRemoteModuleAsync('policy-manager', (remoteEntry) => remoteEntry.PolicyExternalApprovalModule),
  loadPolicyInternalApprovalAsync: () => loadRemoteModuleAsync('policy-manager', (remoteEntry) => remoteEntry.PolicyExternalApprovalModule),
};

export const unifiedControlsApp = {
  loadUnifiedControlsAppAsync: () => loadRemoteModuleAsync('unified-controls', (remoteEntry) => remoteEntry.RemoteEntryModule)
};

export const complianceApp = {
  loadComplianceAsync: () => loadRemoteModuleAsync('compliance', (remoteEntry) => remoteEntry.ComplianceModule),
  loadExternalComplianceAsync: () => loadRemoteModuleAsync('compliance', (remoteEntry) => remoteEntry.ExternalComplianceModule),
};

export const userAccessReviewApp = {
  loadUserAccessAppAsync: () => loadRemoteModuleAsync('user-access-review', (remoteEntry) => remoteEntry.UserAccessReviewModule),
  loadUserAccessPreviewAsync: () => loadRemoteModuleAsync('user-access-review', (remoteEntry) => remoteEntry.UserAccessReviewPreviewModule),
  loadUserAccessExternalAsync: () => loadRemoteModuleAsync('user-access-review', (remoteEntry) => remoteEntry.UarExternalApprovalModule),
  loadUserAccessInternalAsync: () => loadRemoteModuleAsync('user-access-review', (remoteEntry) => remoteEntry.UarExternalApprovalModule)
};

export const integrationsApp = {
  loadMyAnecdotesAsync: () => loadRemoteModuleAsync('integrations', (remoteEntry) => remoteEntry.MyAnecdotesModule),
  loadCollaborationsAsync: () => loadRemoteModuleAsync('integrations', (remoteEntry) => remoteEntry.CollaborationsModule),
  loadPluginConnectionModuleAsync: () => loadRemoteModuleAsync('integrations', (remoteEntry) => remoteEntry.PluginConnectionModule),
  loadPluginsModuleAsync: () => loadRemoteModuleAsync('integrations', (remoteEntry) => remoteEntry.PluginsModule),
  loadIntegrationSettingsAsync: () => loadRemoteModuleAsync('integrations',  (remoteEntry) => remoteEntry.IntegrationSettingsModule)
};

export const riskManagementApp = {
  loadRiskManagementAppAsync: () => loadRemoteModuleAsync('risk-management', (remoteEntry) => remoteEntry.RiskManagementModule),
  loadRiskExternalApprovalAsync: () => loadRemoteModuleAsync('risk-management', (remoteEntry) => remoteEntry.RiskExternalApprovalModule),
  loadRiskInternalApprovalAsync: () => loadRemoteModuleAsync('risk-management', (remoteEntry) => remoteEntry.RiskExternalApprovalModule),
};

export const userManagementApp = {
  loadAccessManagementAsync: () => loadRemoteModuleAsync('user-management', (remoteEntry) => remoteEntry.AccessManagementModule),
  loadScimAsync: () => loadRemoteModuleAsync('user-management', (remoteEntry) => remoteEntry.ScimModule),
  loadLoginMethodsAsync: () => loadRemoteModuleAsync('user-management', (remoteEntry) => remoteEntry.LoginMethodsModule)
};

export const playbookApp = {
  loadAsync: () => loadRemoteModuleAsync('playbook', (remoteEntry) => remoteEntry.RemoteEntryModule),
};
